(function () {
  function init(root) {
    if (!root) return;
    if (root._lifestyleStop) root._lifestyleStop();
    root.dataset.lifestyleReady = "true";

    var slides = Array.prototype.slice.call(root.querySelectorAll("[data-slide]"));
    if (!slides.length) return;

    var index = slides.findIndex(function (slide) {
      return slide.classList.contains("is-active");
    });
    if (index < 0) index = 0;
    var seconds = Number(root.getAttribute("data-interval"));
    if (!seconds || seconds < 3) seconds = 5;

    function show(next) {
      index = (next + slides.length) % slides.length;
      slides.forEach(function (slide, i) {
        var on = i === index;
        slide.classList.toggle("is-active", on);
        slide.hidden = !on;
      });
      root.querySelectorAll("[data-dot]").forEach(function (dot) {
        var on = Number(dot.getAttribute("data-dot")) === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-current", on ? "true" : "false");
      });
    }

    function stop() {
      if (root._ozLifestyleTimer) window.clearInterval(root._ozLifestyleTimer);
      root._ozLifestyleTimer = null;
    }

    function start() {
      stop();
      if (slides.length < 2) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      root._ozLifestyleTimer = window.setInterval(function () {
        if (document.hidden) return;
        show(index + 1);
      }, seconds * 1000);
    }

    if (root.dataset.lifestyleBound !== "true") {
      root.dataset.lifestyleBound = "true";

      root.addEventListener("click", function (event) {
        var dot = event.target.closest("[data-dot]");
        if (!dot || !root.contains(dot)) return;
        show(Number(dot.getAttribute("data-dot")));
        start();
      });

      var startX = 0;
      root.addEventListener("pointerdown", function (event) {
        if (event.target.closest("[data-dot]")) return;
        startX = event.clientX;
        root.classList.add("is-grabbing");
      });
      root.addEventListener("pointerup", function (event) {
        root.classList.remove("is-grabbing");
        if (event.target.closest("[data-dot]")) return;
        var delta = event.clientX - startX;
        if (Math.abs(delta) < 40) return;
        show(index + (delta < 0 ? 1 : -1));
        start();
      });
      root.addEventListener("pointercancel", function () {
        root.classList.remove("is-grabbing");
      });
    }

    start();
    root._lifestyleStop = stop;
  }

  function boot() {
    document.querySelectorAll("[data-lifestyle]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector("[data-lifestyle]");
    if (root) init(root);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var root = event.target.querySelector("[data-lifestyle]");
    if (root && root._lifestyleStop) root._lifestyleStop();
  });
})();
